/** Canonicals never inherit preview, search, tracking parameters, or a supplied origin. */
export function canonicalUrl(origin: string, pathname: string) {
  const url = new URL(origin);
  url.pathname = pathname.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  url.search = "";
  url.hash = "";
  return url.href;
}

export function safeJson(value: unknown) {
  return JSON.stringify(value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

export function xmlEscape(value: string) {
  return value.replace(
    /[<>&"']/g,
    (character) =>
      ({ "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;", "'": "&apos;" })[character]!,
  );
}

/** `lastModified` maps a URL to the ISO day it last changed; list only dates that are true. */
export function sitemapXml(
  urls: readonly string[],
  lastModified: ReadonlyMap<string, string> = new Map(),
) {
  return `<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">${[
    ...new Set(urls),
  ]
    .map((url) => {
      const day = lastModified.get(url);
      return `<url><loc>${xmlEscape(url)}</loc>${day ? `<lastmod>${xmlEscape(day)}</lastmod>` : ""}</url>`;
    })
    .join("")}</urlset>`;
}
